import React from "react";
import {
  Modal,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "none",
  outline: "none",
  display: "flex",
  bgcolor: "background.paper",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

const ImagePopup = ({ imageUrl, open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Stack sx={style} gap={0} lineHeight={0}>
        <Box width={"100%"} mt={0} textAlign={"right"}>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box mb={0} pb={3}>
          <img
            src={imageUrl}
            alt="Preview"
            style={{
              width: "400px",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </Box>
      </Stack>
    </Modal>
  );
};

export default ImagePopup;
